export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_15.4634d3ea.jpg";